import type { TenantNotFoundError } from "@scayla/api-client-fetch";

export function isTenantNotFoundError(error: unknown): error is TenantNotFoundError {
  return !!error && typeof error === "object" && (error as { errorCode?: unknown }).errorCode === "TenantNotFoundError";
}
